import { Output } from './types';

let worker: Worker;
let initializated = false;
let initPromise: Promise<void>;

function init() {
  if (process.env.NODE_ENV === 'test') return;
  if (!worker) {
    // console.log('Initializing web worker');
    if (!import.meta.url) {
      throw new Error('import.meta.url is not defined!');
    }
    const w = new Worker(
      new URL(
        /* webpackChunkName: "cloudio-worker" */ './cloudio-worker.js',
        import.meta.url,
      ),
    );
    w.addEventListener('message', ({ data }: { data: Output }) => {
      const { type, id, result, error } = data;
      if (type !== 'IO') {
        console.error(`Unknown message type: ${type}`, data);
        return;
      }
      if (error) {
        CACHE[id][1](error);
      } else {
        CACHE[id][0](result);
      }
      delete CACHE[id];
    });
    worker = w;
  }
}

const CACHE: Record<string, [any, any]> = {};
let nextId = 0;

export async function initWasm() {
  if (initializated) return;
  init();
  if (!initPromise) {
    // console.log('CloudIO worker initializing...');
    initPromise = post('initWasm');
  }
  await initPromise;
  initializated = true;
  // console.log('CloudIO worker initialized');
}

export async function post<I, O>(method: string, params?: I): Promise<O> {
  if (!initializated && method !== 'initWasm') {
    await initWasm();
  }
  return new Promise((resolve, reject) => {
    nextId += 1;
    const id = nextId;
    CACHE[id] = [resolve, reject];
    worker.postMessage({
      type: 'IO',
      method,
      params,
      id,
    });
  });
}

export async function gzip(value: string): Promise<Uint8Array> {
  if (process.env.NODE_ENV === 'test') {
    return new Uint8Array();
  }
  return post('gzip', value);
}

export async function gunzip(value: Uint8Array): Promise<string> {
  if (process.env.NODE_ENV === 'test') {
    return 'test';
  }
  return post('gunzip', value);
}

interface TransformResult {
  code?: string | null;
  error?: string;
}

export async function transform(
  name: string,
  source: string,
  debug: boolean,
): Promise<TransformResult> {
  if (process.env.NODE_ENV === 'test') {
    return { error: 'Not implemented' };
  }
  return post('transform', { name, source, debug }) as TransformResult;
}
